export default __webpack_public_path__ + "static/media/vip-4.b1cbb2f2.gif";